import { useFormWithSchema } from '../../../utils/functions/yupFormTypescript';
import { useAlertHelper } from '../../../utils/functions/hooks';
import { TAutoCompleteOptions } from '../../../utils/types';
/* eslint-disable @typescript-eslint/no-explicit-any */
import './index.scss';
import {
  AppBar,
  Box,
  Drawer,
  useMediaQuery,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import {
  DropDownType,
  formSchema,
  ListType,
  MVPFormData,
  FormInitialValue,
} from '../constants';
import {
  ArrowDropDown,
  ArrowDropUp,
  FilterAltOutlined,
} from '@mui/icons-material';
import FiltersView from './FiltersView';
import { useUpdateDropdownHierarchyQuery } from '../../../services/mVPGraphQlService';
import React from 'react';
import { useFilterContext } from '../../../services/mVPMapService/filterContext';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

type MVPFiltersProps = {
  // filtersIsCollapsed: boolean;
  handleApplyFilter: (values: MVPFormData) => void;
  filterValues: MVPFormData;
  setFilterOpen: any;
};

export const MVPFilters: React.FC<MVPFiltersProps> = ({
  // filtersIsCollapsed,
  filterValues,
  handleApplyFilter,
  filterValues: commonFilters,
  setFilterOpen,
}) => {
  const { showError } = useAlertHelper();
  const isMobileView: boolean = useMediaQuery(
    '(max-width:1024px)'
  );
  const headerRef = useRef<HTMLElement | null>(null);

  const formReturn = useFormWithSchema(formSchema, {
    mode: 'onTouched',
    defaultValues: filterValues || FormInitialValue,
  });
  const {
    control,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
    watch,
    register,
  } = formReturn;

  const countryName = useSelector(
    (state: RootState) => state.country.countryName
  );

  // Sync country from header dropdown into the form
  useEffect(() => {
    setValue('country', countryName);
    // Reset filters that are country-specific
    setValue('season', '');
    setValue('region', null);
    setValue('subRegion', null);
    setValue('cluster', null);
    setValue('village', null);
    setValue('regionManager', null);
    setValue('tpm', null);
    setValue('fa', null);
    setValue('organizer', null);
    setValue('cropType', null);
    setValue('hybridType', null);
    // Clear the context so chart components don't use stale values
    handleApplyFilter({
      ...watch(),
      country: countryName,
      season: '',
      region: null,
      subRegion: null,
      cluster: null,
      village: null,
      regionManager: null,
      tpm: null,
      fa: null,
      organizer: null,
      cropType: null,
      hybridType: null,
    });
  }, [countryName]);
  const {
    regionManagerList,
    tpmList,
    faList,
    hybridTypeList,
    weeksOfSowing,
    setRegionManagerList,
    setTpmList,
    setFaList,
    setRegionManagerListFfc,
    setTpmListFfc,
    setPlListFfc,
    setScmListFfc,
    setHybridTypeList,
    setWeeksOfSowing,
  } = useFilterContext();
  const [, setCountryList] = useState<DropDownType[]>([]);
  const [regionList, setRegionList] = useState<
    DropDownType[]
  >([]);
  const [subregionList, setSubregionList] = useState<
    DropDownType[]
  >([]);
  const [villageList, setVillageList] = useState<
    DropDownType[]
  >([]);
  const [clusterList, setClusterList] = useState<
    DropDownType[]
  >([]);
  // const [regionManagerList, setRegionManagerList] =
  //   useState<DropDownType[]>([]);
  // const [tpmList, setTpmList] = useState<DropDownType[]>(
  //   []
  // );
  // const [faList, setFaList] = useState<DropDownType[]>([]);
  const [organizerList, setOrganizerList] = useState<
    DropDownType[]
  >([]);
  const [indexIdList, setIndexIdList] = useState<
    DropDownType[]
  >([]);
  // const [weekOfSowing, setWeekOfSowing] = useState<
  //   DropDownType[]
  // >([]);

  const [cropTypeList, setCropTypeList] = useState<
    DropDownType[]
  >([]);
  // const [hybridTypeList, setHybridTypeList] = useState<
  //   DropDownType[]
  // >([]);
  const [seasonTypeList, setSeasonTypeList] = useState<
    DropDownType[]
  >([]);
  const [isSticky, setIsSticky] = useState(false);
  const [showFilterBottomSheet, setShowFilterBottomSheet] =
    useState<boolean>(false);
  const [isIndexInitialized, setIsIndexInitialized] =
    useState(false);

  const getLastSeason = () => {
    const seasons = seasonTypeList.filter(
      (s) => s.value !== 'All'
    );
    return seasons.length > 0
      ? seasons[seasons.length - 1]?.value
      : '';
  };
  const isThailand =
    useSelector(
      (state: RootState) => state.country.countryName
    ) === 'Thailand';

  useEffect(() => {
    if (
      !isIndexInitialized &&
      indexIdList?.length > 0 &&
      seasonTypeList?.length > 0 &&
      !watch('season') &&
      !filterValues?.season &&
      !watch('index') &&
      !filterValues?.index
    ) {
      setValue('index', indexIdList?.[0]?.value);
      setValue('season', getLastSeason());
      setValue('country', countryName);
      setIsIndexInitialized(true);
    }
  }, [
    indexIdList,
    isIndexInitialized,
    setValue,
    seasonTypeList,
  ]);

  useEffect(() => {
    if (
      filterValues &&
      filterValues.index &&
      filterValues.season
    ) {
      reset(filterValues);
    }
  }, [filterValues, reset]);

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef?.current) {
        const stickyOffset = headerRef?.current?.offsetTop;
        if (
          isMobileView &&
          window?.pageYOffset > stickyOffset
        ) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobileView]);
  const wsId = useSelector(
    (state: RootState) => state.country.wsId
  );
  const [queryArgs, setQueryArgs] = useState({
    commonFilters,
    fullHierarchy: true,
    wsId: wsId,
  });

  const { data } =
    useUpdateDropdownHierarchyQuery(queryArgs);

  useEffect(() => {
    const unsubscribe = watch((values) => {
      const normalizedValues = {
        ...values,
        country: values.country ?? null,
        region: values.region ?? null,
        subRegion: values.subRegion ?? null,
        village: values.village ?? null,
        cluster: values.cluster ?? null,
        // regionManager: values.regionManager ?? null,
        // tpm: values.tpm ?? null,
        // fa: values.fa ?? null,
        regionManager: Array.isArray(values.regionManager)
          ? null
          : values.regionManager ?? null,
        tpm: Array.isArray(values.tpm)
          ? null
          : values.tpm ?? null,
        fa: Array.isArray(values.fa)
          ? null
          : values.fa ?? null,
        organizer: values.organizer ?? null,
        index: values.index ?? null,
        season: values.season ?? '',
      };

      setQueryArgs((prev) => ({
        ...prev,
        commonFilters: normalizedValues,
        fullHierarchy: true,
      }));
    });

    return () => unsubscribe.unsubscribe();
  }, [watch]);

  // Update queryArgs when wsId changes from header dropdown
  useEffect(() => {
    setQueryArgs((prev) => ({
      ...prev,
      wsId: wsId,
    }));
  }, [wsId]);

  const handleBottomSheetOpen = (value: boolean) => {
    setShowFilterBottomSheet(value);
  };

  const handleSubmitData = (values: MVPFormData) => {
    handleApplyFilter(values);
    handleBottomSheetOpen(false);
  };

  const isInitialRender = useRef(true);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }

    const lastSeason = getLastSeason();
    if (
      watch('country') == countryName &&
      watch('index') == indexIdList?.[0]?.value &&
      watch('season') == lastSeason
    ) {
      const existingFilters = watch();
      const updatedFilters = {
        ...existingFilters,
        country: countryName,
        index: indexIdList?.[0]?.value,
        season: lastSeason,
      };

      handleApplyFilter(updatedFilters);
    }
  }, [watch('country'), watch('index'), watch('season')]);

  const handleClearAll = () => {
    const retainedValues = {
      country: countryName,
      // cropType: 'Corn',
      index: indexIdList?.[0]?.value,
      season: getLastSeason(),
    };

    reset({
      ...retainedValues,
      fa: null,
      farmType: null,
      hybridType: null,
      organizer: null,
      region: null,
      regionManager: null,
      sowingEndDate: null,
      sowingStartDate: null,
      subRegion: null,
      tpm: null,
      village: null,
      cluster: null,
    });

    getDropDownsList();
    handleApplyFilter(watch());
    handleBottomSheetOpen(false);
  };

  const getDropDownsList = () => {
    const formattedListOfIndexes = getFormattedListArray(
      data?.data?.UpdateDropdownHierarchy?.indexList || []
    );
    const formattedListOfWos = getFormattedListArray(
      data?.data?.UpdateDropdownHierarchy?.weeksOfSowing ||
        []
    ).sort((a, b) => a.id - b.id);

    const formattedListOfSeason = [
      ...getFormattedListArray(
        data?.data?.UpdateDropdownHierarchy
          ?.countrySeasonMapping?.[0]?.seasonList || []
      ),
      ...(countryName === 'Thailand'
        ? [
            { id: 'W2026', name: 'W2026' },
            { id: 'D2026', name: 'D2026' },
          ]
        : []),
      ...(countryName === 'India'
        ? [{ id: 'R2026', name: 'R2026' }]
        : []),
      { id: 'All', name: 'All' },
    ];

    const formattedListOfCrop = getFormattedListArray(
      data?.data?.UpdateDropdownHierarchy?.cropList || []
    );
    const formattedListOfHybrid = getFormattedListArray(
      data?.data?.UpdateDropdownHierarchy?.hybridList || []
    );

    const formattedListofCountry = country?.map((item) => ({
      id: item?.name,
      name: item?.name,
      parentId: item?.parentId,
    }));

    setIndexIdList(
      getFormattedList(formattedListOfIndexes || [])
    );
    setWeeksOfSowing(
      getFormattedList(formattedListOfWos || [])
    );
    setSeasonTypeList(
      getFormattedList(formattedListOfSeason || [])
    );
    setCropTypeList(
      getFormattedList(
        (formattedListOfCrop || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );

    setHybridTypeList(
      getFormattedList(
        (formattedListOfHybrid || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );

    setCountryList(
      getFormattedList(
        (formattedListofCountry || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );

    setRegionManagerList(
      getFormattedList(
        (formattedListofManagers || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );
    setTpmList(
      getFormattedList(
        (formattedListoTpm || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );
    setFaList(
      getFormattedList(
        (formattedListofFa || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );
    setOrganizerList(
      getFormattedList(
        (formattedListofOrganizer || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );
    setRegionManagerListFfc(
      getFormattedList(
        (formattedListoRmffc || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );
    setTpmListFfc(
      getFormattedList(
        (formattedListoTpmffc || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );
    setScmListFfc(
      getFormattedList(
        (formattedListoScmffc || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );
    setPlListFfc(
      getFormattedList(
        (formattedListoPlffc || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );
    setRegionList(
      getFormattedList(
        (formattedListofRegion || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );

    setSubregionList(
      getFormattedList(
        (formattedListofSubRegion || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );
    setClusterList(
      getFormattedList(
        (formattedListofCluster || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );

    setVillageList(
      getFormattedList(
        (formattedListofVillage || [])
          .filter((item) => item.name)
          .sort((a, b) => a.name.localeCompare(b.name))
      )
    );
  };

  const getFormattedListArray = (
    list: Array<string>
  ): ListType[] => {
    const formattedList = list?.map((item) => ({
      id: item,
      name: item,
    }));
    return formattedList;
  };

  const getFormattedList = (
    list: Array<ListType>,
    parentId?: string | null
  ): DropDownType[] => {
    if (parentId) {
      const formattedList = list
        .filter((item) => item?.parentId === parentId)
        .map((item) => ({
          label: item?.name,
          value: item?.id,
        }));
      return formattedList;
    } else {
      const formattedList = list?.map((item) => ({
        label: item?.name,
        value: item?.id,
      }));
      return formattedList;
    }
  };

  function getRegionalManagers(
    hierarchy: any[],
    type: string,
    parentId: number | null = null
  ): any[] {
    const regionalManagers: {
      type: string;
      name: string;
      id: number;
      parentId: number;
    }[] = [];

    hierarchy.forEach((item) => {
      if (item.data?.type === type) {
        regionalManagers.push({
          ...item.data,
          parentId, // Include parent ID
        });
      }

      if (item.hierarchy && Array.isArray(item.hierarchy)) {
        // Recursively check the child hierarchy and pass the current item's ID as parentId
        regionalManagers.push(
          ...getRegionalManagers(
            item.hierarchy,
            type,
            item.data?.id || null
          )
        );
      }
    });

    return regionalManagers;
  }

  function getRegion(
    children: any[],
    type: string,
    parentId: number | null = null
  ): any[] {
    const regionalManagers: {
      type: string;
      name: string;
      id: number;
      parentId: number;
    }[] = [];

    children.forEach((item) => {
      if (item.data?.type === type) {
        regionalManagers.push({
          ...item.data,
          parentId: parentId || null, // Use parentId or null
        });
      }

      if (item.children && Array.isArray(item.children)) {
        // Recursively check the child children and pass the current item's name as parentId
        regionalManagers.push(
          ...getRegion(
            item.children,
            type,
            item.data?.type === 'SUB_REGION' &&
              item.data.name === ''
              ? parentId
              : item.data?.name || null
          )
        );
      }
    });

    return regionalManagers;
  }

  const regionalManagers = getRegionalManagers(
    data?.data?.UpdateDropdownHierarchy?.empHierarchy
      ?.hierarchy || [],
    'REGION_MANAGER'
  );

  const tManagers = getRegionalManagers(
    data?.data?.UpdateDropdownHierarchy?.empHierarchy
      ?.hierarchy || [],
    'TPM'
  );

  const fa = getRegionalManagers(
    data?.data?.UpdateDropdownHierarchy?.empHierarchy
      ?.hierarchy || [],
    'FA'
  );

  const organizers = getRegionalManagers(
    data?.data?.UpdateDropdownHierarchy?.empHierarchy
      ?.hierarchy || [],
    'ORGANIZER'
  );

  const regionalManagersFFC = getRegionalManagers(
    data?.data?.UpdateDropdownHierarchy?.empHierarchyFfc
      ?.hierarchy || [],
    'REGION_MANAGER'
  );
  const tpmFFC = getRegionalManagers(
    data?.data?.UpdateDropdownHierarchy?.empHierarchyFfc
      ?.hierarchy || [],
    'TPM'
  );
  const ScmFFC = getRegionalManagers(
    data?.data?.UpdateDropdownHierarchy?.empHierarchyFfc
      ?.hierarchy || [],
    'SCM_LEAD'
  );
  const plFFC = getRegionalManagers(
    data?.data?.UpdateDropdownHierarchy?.empHierarchyFfc
      ?.hierarchy || [],
    'PRODUCTION_LEAD'
  );
  const country = getRegion(
    data?.data?.UpdateDropdownHierarchy?.geoHierarchy || [],
    'COUNTRY'
  );
  const region = getRegion(
    data?.data?.UpdateDropdownHierarchy?.geoHierarchy || [],
    'REGION'
  );

  const subRegion = getRegion(
    data?.data?.UpdateDropdownHierarchy?.geoHierarchy || [],
    'SUB_REGION'
  );
  const cluster = getRegion(
    data?.data?.UpdateDropdownHierarchy?.geoHierarchy || [],
    'CLUSTER'
  );
  const village = getRegion(
    data?.data?.UpdateDropdownHierarchy?.geoHierarchy || [],
    'VILLAGE'
  );

  const formattedListofManagers = regionalManagers?.map(
    (item) => ({
      id: item?.id,
      name: item?.name,
    })
  );

  const formattedListoTpm = tManagers?.map((item) => ({
    id: item?.id,
    name: item?.name,
    parentId: item?.parentId,
  }));

  const formattedListofFa = fa?.map((item) => ({
    id: item?.id,
    name: item?.name,
    parentId: item?.parentId,
  }));

  const formattedListofOrganizer = Array.isArray(organizers)
    ? organizers
        .map((item) => ({
          id: item?.id,
          name: item?.name,
          parentId: item?.parentId,
        }))
        .filter(
          (item, index, self) =>
            index ===
            self.findIndex((t) => t.id === item.id)
        )
    : [];
  const formattedListoRmffc = regionalManagersFFC?.map(
    (item) => ({
      id: item?.id,
      name: item?.name,
      parentId: item?.parentId,
    })
  );
  const formattedListoTpmffc = tpmFFC?.map((item) => ({
    id: item?.id,
    name: item?.name,
    parentId: item?.parentId,
  }));
  const formattedListoScmffc = ScmFFC?.map((item) => ({
    id: item?.id,
    name: item?.name,
    parentId: item?.parentId,
  }));
  const formattedListoPlffc = plFFC?.map((item) => ({
    id: item?.id,
    name: item?.name,
    parentId: item?.parentId,
  }));
  const formattedListofRegion = region?.map((item) => ({
    id: item?.name,
    name: item?.name,
    parentId: item?.parentId,
  }));
  const formattedListofSubRegion = subRegion?.map(
    (item) => ({
      id: item?.name,
      name: item?.name,
      parentId: item?.parentId,
    })
  );
  const formattedListofCluster = cluster?.map((item) => ({
    id: item?.name,
    name: item?.name,
    parentId: item?.parentId,
  }));
  const formattedListofVillage = village?.map((item) => ({
    id: item?.name,
    name: item?.name,
    parentId: item?.parentId,
  }));

  useEffect(() => {
    if (data) {
      getDropDownsList();
      // Auto-set index to first available when data refreshes
      const indexList =
        data?.data?.UpdateDropdownHierarchy?.indexList ||
        [];
      if (indexList.length > 0 && !watch('index')) {
        setValue('index', indexList[0]);
      }
      // Auto-set season to last available season when data refreshes (e.g., country change)
      const seasonList =
        data?.data?.UpdateDropdownHierarchy
          ?.countrySeasonMapping?.[0]?.seasonList || [];
      if (seasonList.length > 0 && !watch('season')) {
        const lastSeason =
          seasonList[seasonList.length - 1];
        setValue('season', lastSeason);
      }

      // Apply filters after setting index/season so APIs get called
      const currentValues = watch();
      if (
        currentValues.country &&
        currentValues.index &&
        currentValues.season
      ) {
        handleApplyFilter(currentValues);
      }
    }
  }, [data]);

  const handleRegionChange = (
    selectedOption: TAutoCompleteOptions | null
  ) => {
    const value = selectedOption?.value as string;

    setValue('subRegion', null);
    setValue('cluster', null);
    setValue('village', null);

    setSubregionList([]);
    setClusterList([]);
    setVillageList([]);

    if (value) {
      setSubregionList(
        getFormattedList(formattedListofSubRegion, value)
      );

      if (isThailand) {
        setClusterList(
          getFormattedList(formattedListofCluster, value)
        );
      }

      // preserve existing india behaviour
      setVillageList(
        getFormattedList(formattedListofVillage, value)
      );
    } else {
      setSubregionList(
        getFormattedList(formattedListofSubRegion)
      );

      if (isThailand) {
        setClusterList(
          getFormattedList(formattedListofCluster)
        );
      }

      setVillageList(
        getFormattedList(formattedListofVillage)
      );
    }

    setValue('region', value || null);

    const country = getParentValue(
      formattedListofRegion,
      value
    );

    setValue('country', country || null);
  };

  const handleSubRegionChange = (
    selectedOption: TAutoCompleteOptions | null
  ) => {
    const value = selectedOption?.value as string;

    setValue('cluster', null);
    setValue('village', null);

    setClusterList([]);
    setVillageList([]);

    if (value) {
      const region = getParentValue(
        formattedListofSubRegion,
        value
      );

      setValue('region', region);

      const country = getParentValue(
        formattedListofRegion,
        region || ''
      );

      setValue('country', country || null);

      if (isThailand) {
        setClusterList(
          getFormattedList(formattedListofCluster, value)
        );
      } else {
        setVillageList(
          getFormattedList(formattedListofVillage, value)
        );
      }
    } else {
      if (isThailand) {
        setClusterList(
          getFormattedList(formattedListofCluster)
        );
      } else {
        setVillageList(
          getFormattedList(formattedListofVillage)
        );
      }
    }

    setValue('subRegion', value || null);
  };

  const handleClusterChange = (
    selectedOption: TAutoCompleteOptions | null
  ) => {
    const value = selectedOption?.value as string;

    setValue('village', null);

    if (value) {
      setVillageList(
        getFormattedList(formattedListofVillage, value)
      );

      const subRegion = getParentValue(
        formattedListofCluster,
        value
      );

      setValue('subRegion', subRegion);

      const region = getParentValue(
        formattedListofSubRegion,
        subRegion || ''
      );

      setValue('region', region);

      const country = getParentValue(
        formattedListofRegion,
        region || ''
      );

      setValue('country', country || null);
    } else {
      setVillageList(
        getFormattedList(formattedListofVillage)
      );
    }

    setValue('cluster', value || null);
  };

  const handleVillageChange = (
    selectedOption: TAutoCompleteOptions | null
  ) => {
    const value = selectedOption?.value as string | null;

    setValue('village', value || null);

    if (!value) return;

    if (isThailand) {
      if (isThailand) {
        const cluster = getParentValue(
          formattedListofVillage,
          value
        );

        setValue('cluster', cluster);

        const subRegion = getParentValue(
          formattedListofCluster,
          cluster || ''
        );

        setValue('subRegion', subRegion);

        const region = getParentValue(
          formattedListofSubRegion,
          subRegion || ''
        );

        setValue('region', region);

        const country = getParentValue(
          formattedListofRegion,
          region || ''
        );

        setValue('country', country || null);
      }
    } else {
      const parentId = getParentValue(
        formattedListofVillage,
        value
      );

      const subRegion = getIdOfList(
        formattedListofSubRegion,
        parentId
      );

      setValue('subRegion', subRegion);

      const region = getParentValue(
        formattedListofSubRegion,
        subRegion || ''
      );

      setValue('region', region);
    }
  };

  const handleRegionMangerChange = (
    selectedOption: TAutoCompleteOptions | null
  ) => {
    const value = selectedOption?.value as string;
    setValue('fa', null);
    setFaList([]);
    setValue('tpm', null);
    setTpmList([]);
    if (value) {
      setTpmList(
        getFormattedList(formattedListoTpm, value)
      );
    } else {
      setTpmList(getFormattedList(formattedListoTpm));
      setFaList(getFormattedList(formattedListofFa));
      setOrganizerList(
        getFormattedList(formattedListofOrganizer)
      );
    }
    setValue('regionManager', value ? value : null);
  };

  const handleTpmChange = (
    selectedOption: TAutoCompleteOptions | null
  ) => {
    const value = selectedOption?.value as string;
    setValue('fa', null);
    setFaList([]);
    if (value) {
      setFaList(getFormattedList(formattedListofFa, value));
      const region_manager = getParentValue(
        formattedListoTpm,
        value
      );
      setValue('regionManager', region_manager);
    }
    setValue('tpm', value ? value : null);
  };

  const handleFaChange = (
    selectedOption: TAutoCompleteOptions | null
  ) => {
    const value = selectedOption?.value as string;
    if (value) {
      setOrganizerList(
        getFormattedList(formattedListofOrganizer, value)
      );
      const tpm_id = getParentValue(
        formattedListofFa,
        value
      );
      setValue('tpm', tpm_id);
      const region_manager = getParentValue(
        formattedListoTpm,
        tpm_id ? tpm_id : ''
      );
      setValue('regionManager', region_manager);
    }
    setValue('fa', value ? value : null);
  };

  const handleOrganizerChange = (
    selectedOption: TAutoCompleteOptions | null
  ) => {
    const value = selectedOption?.value as string;
    setValue('organizer', value ? value : null);
  };

  const getParentValue = (
    list: ListType[],
    chidValue: string
  ) => {
    const item = list.find(
      (entry) => entry?.id === chidValue
    );
    return item ? item?.parentId : null;
  };

  const getIdOfList = (
    list: ListType[],
    chidValue: string | null | undefined
  ) => {
    const item = list.find(
      (entry) => entry?.id === chidValue
    );
    return item ? item?.id : null;
  };

  const handleErrorOnSubmit = (error: unknown) => {
    showError(
      'Please fill all the mandatory details first'
    );
    console.log(error);
  };

  const handelSowingStartDateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValue('sowingStartDate', event?.target?.value);
  };

  const handleSowingEndDateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValue('sowingEndDate', event?.target?.value);
  };

  return (
    <>
      {isMobileView ? (
        <>
          <AppBar
            ref={headerRef}
            position={isSticky ? 'fixed' : 'static'}
            className="app-bar-container"
            style={{
              top: isSticky ? 0 : '',
            }}
            onClick={() =>
              handleBottomSheetOpen(
                showFilterBottomSheet == true ? false : true
              )
            }>
            <Box className="bar-text-container">
              <Box
                component={'span'}
                className="filter-icon-text">
                <FilterAltOutlined />
              </Box>
              <Box
                component={'span'}
                className="filter-icon-text">
                Filter
              </Box>
              <Box
                component={'span'}
                className="arrow-icons">
                {showFilterBottomSheet ? (
                  <ArrowDropUp />
                ) : (
                  <ArrowDropDown />
                )}
              </Box>
            </Box>
          </AppBar>
          <Drawer
            anchor="bottom"
            open={showFilterBottomSheet}
            onClose={() => handleBottomSheetOpen(false)}
            PaperProps={{
              sx: {
                borderRadius: '16px 16px 0 0',
                padding: 2,
              }, // Customize appearance
            }}>
            <Box sx={{ height: '80vh' }}>
              <FiltersView
                control={control}
                errors={errors}
                register={register}
                handleSubmit={handleSubmit}
                handleSubmitData={handleSubmitData}
                handleErrorOnSubmit={handleErrorOnSubmit}
                handleBottomSheetOpen={
                  handleBottomSheetOpen
                }
                regionManagerList={regionManagerList}
                tpmList={tpmList}
                faList={faList}
                organizerList={organizerList}
                indexIdList={indexIdList}
                regionList={regionList}
                subregionList={subregionList}
                villageList={villageList}
                cropTypeList={cropTypeList}
                hybridTypeList={hybridTypeList}
                seasonTypeList={seasonTypeList}
                handleRegionMangerChange={
                  handleRegionMangerChange
                }
                handleTpmChange={handleTpmChange}
                handleFaChange={handleFaChange}
                handleOrganizerChange={
                  handleOrganizerChange
                }
                handleRegionChange={handleRegionChange}
                handleSubRegionChange={
                  handleSubRegionChange
                }
                handleVillageChange={handleVillageChange}
                handelSowingStartDateChange={
                  handelSowingStartDateChange
                }
                handleSowingEndDateChange={
                  handleSowingEndDateChange
                }
                handleClearAll={handleClearAll}
              />
            </Box>
          </Drawer>
        </>
      ) : (
        <>
          <Box>
            <FiltersView
              setFilterOpen={setFilterOpen}
              control={control}
              errors={errors}
              register={register}
              handleSubmit={handleSubmit}
              handleSubmitData={handleSubmitData}
              handleErrorOnSubmit={handleErrorOnSubmit}
              handleBottomSheetOpen={handleBottomSheetOpen}
              regionManagerList={regionManagerList}
              tpmList={tpmList}
              faList={faList}
              organizerList={organizerList}
              indexIdList={indexIdList}
              regionList={regionList}
              subregionList={subregionList}
              villageList={villageList}
              cropTypeList={cropTypeList}
              hybridTypeList={hybridTypeList}
              seasonTypeList={seasonTypeList}
              weeksOfSowing={weeksOfSowing}
              handleRegionMangerChange={
                handleRegionMangerChange
              }
              handleTpmChange={handleTpmChange}
              handleFaChange={handleFaChange}
              handleOrganizerChange={handleOrganizerChange}
              handleRegionChange={handleRegionChange}
              handleSubRegionChange={handleSubRegionChange}
              handleVillageChange={handleVillageChange}
              clusterList={clusterList}
              handleClusterChange={handleClusterChange}
              handelSowingStartDateChange={
                handelSowingStartDateChange
              }
              handleSowingEndDateChange={
                handleSowingEndDateChange
              }
              handleClearAll={handleClearAll}
            />
          </Box>
        </>
      )}
    </>
  );
};
